"use client"

import { useCallback, useState } from "react"

export interface ViaCepResult {
  cep: string
  logradouro: string
  bairro: string
  cidade: string
  estado: string
}

interface ViaCepResponse {
  cep?: string
  logradouro?: string
  bairro?: string
  localidade?: string
  uf?: string
  erro?: boolean
}

/**
 * Consulta CEP no ViaCEP. Retorna null se inválido ou não encontrado.
 * NÃO bloqueia o usuário, se a API falhar, ele preenche manualmente.
 */
export function useViaCep() {
  const [loading, setLoading] = useState(false)

  const consultar = useCallback(async (cepInput: string): Promise<ViaCepResult | null> => {
    const cep = cepInput.replace(/\D/g, "")
    if (cep.length !== 8) return null

    setLoading(true)
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
      if (!res.ok) return null
      const data: ViaCepResponse = await res.json()
      if (data.erro) return null
      return {
        cep,
        logradouro: data.logradouro || "",
        bairro: data.bairro || "",
        cidade: data.localidade || "",
        estado: (data.uf || "").toUpperCase(),
      }
    } catch {
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return { consultar, loading }
}

export function mascararCep(valor: string): string {
  const d = valor.replace(/\D/g, "").slice(0, 8)
  if (d.length <= 5) return d
  return `${d.slice(0, 5)}-${d.slice(5)}`
}
